import { useState } from 'react';

import config from 'config';
import { PAYMENT_PLAN_TYPE } from 'core/services/bff';
import { checkout, CHECKOUT_VIEW, PIX_PAYMENT_FLAG } from 'core';

import { useCreditCardError } from './useCreditCardError.hooks';
import type { CheckoutViews } from 'core';
import type { CreditCard, MessengerEvent } from './CreditCard.d';
import { useConfigCatClient } from 'configcat-react';

export const useCreditCard = (): CreditCard => {
  const [isIframeError, setIsIFrameError] = useState<boolean>(false);
  const [isIFrameLoaded, setIsIFrameLoaded] = useState<boolean>(false);
  const [statusCode, setStatusCode] = useState<number>();
  const clientConfigCat = useConfigCatClient();
  const { errorFlow } = useCreditCardError();
  const { setCreditCardCompleted, setCreditCardOption, setStep, setView } =
    checkout.commands.useCheckoutCommand();

  const handleIFrameRenderer = () => {
    window.scrollTo(0, 0);
  };

  const handleMessage = (event: MessageEvent<MessengerEvent>) => {
    if (event.origin !== config.formCreditCard.baseUrl) {
      return;
    }

    setIsIFrameLoaded(true);

    const isRecievedMessage = event && event?.data;

    if (isRecievedMessage) {
      const {
        action,
        detail,
        error,
        errorType,
        isIframeCompleted,
        payload,
        statusCode: code,
      } = event.data;

      if (!isIframeCompleted) {
        setStatusCode(code);
        setIsIFrameError(true);

        return;
      }

      if (error) {
        setIsIFrameError(true);
        errorFlow('Formulário carregou', code, detail, errorType);

        return;
      }

      if (action === CHECKOUT_VIEW.SUMMARY) {
        setCreditCardCompleted(payload);
        setStep(CHECKOUT_VIEW.SUMMARY as keyof CheckoutViews);

        return;
      }

      if (action === CHECKOUT_VIEW.PAYMENT_SELECTOR) {
        clientConfigCat.getValueDetailsAsync(PIX_PAYMENT_FLAG, false).then((isPixActive) => {
          if (!isPixActive) {
            setCreditCardOption({ paymentMode: PAYMENT_PLAN_TYPE.CREDIT_CARD });
          }
        });
        setView(CHECKOUT_VIEW.PAYMENT_SELECTOR);

        return;
      }

      return;
    }

    errorFlow('Formulário carregou', statusCode, 'Não recebeu o Data entre documentos');
  };

  return { isIframeError, isIFrameLoaded, handleMessage, handleIFrameRenderer };
};
